import React from 'react';
import { useLocation } from 'react-router-dom';
import { ShieldOff } from 'lucide-react';
import { useAuthStore } from '../store/auth';
import { permissionForPath } from './nav';

/**
 * Route qo'riqchisi.
 *
 * Ruxsat yo'q bo'lsa oq sahifa ham, "sahifa topilmadi" ham emas —
 * tushunarli xabar chiqadi. Foydalanuvchi nima bo'lganini bilishi va kimga
 * murojaat qilishni tushunishi kerak.
 *
 * Bu faqat UX qatlami: server ham xuddi shu ruxsatni tekshiradi va API'ga
 * qo'lda yuborilgan so'rovni 403 bilan rad etadi.
 */
export const RequirePermission: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { pathname } = useLocation();
  const rbac = useAuthStore((state) => state.rbac);

  const needed = permissionForPath(pathname);
  if (needed && !(needed in rbac)) {
    return <PermissionDenied />;
  }
  return <>{children}</>;
};

export const PermissionDenied: React.FC = () => (
  <div className="text-center py-16 px-4">
    <div className="mx-auto mb-4 w-14 h-14 rounded-full bg-gray-50 grid place-items-center">
      <ShieldOff className="text-gray-300" size={26} />
    </div>
    <p className="text-gray-900 font-semibold">Bu bo'limga ruxsatingiz yo'q</p>
    <p className="text-sm text-gray-500 mt-1 max-w-sm mx-auto">
      Kerak bo'lsa do'kon egasidan so'rang — u Sozlamalar → Rollar bo'limidan
      ruxsat bera oladi.
    </p>
  </div>
);
